import utils from '@/common/utils'

/**
 * 移动端工具函数
 * 提供令牌生成和验证功能
 */

/**
 * 生成移动端访问令牌
 * @param {string} dataId - 数据ID
 * @param {number} expireTime - 过期时间（秒）
 * @param {Object} additionalData - 额外数据（如表单名称、行ID等）
 * @returns {string} 访问令牌
 */
export function generateMobileToken(dataId, expireTime = 3600, additionalData = {}) {
  const timestamp = Math.floor(Date.now() / 1000)
  const expireTimestamp = timestamp + expireTime
  
  // 令牌数据
  const tokenData = {
    dataId,
    expire: expireTimestamp,
    timestamp,
    ...additionalData
  }
  
  // 使用项目的加密方法
  return utils.encryptKey(JSON.stringify(tokenData), 'mobile')
}

/**
 * 验证移动端访问令牌
 * @param {string} token - 访问令牌
 * @returns {Object|null} 令牌信息或null
 */
export function validateMobileToken(token) {
  if (!token) {
    return null
  }
  
  try {
    // 尝试使用加密方式解析
    const tokenData = utils.decryptKey(token, 'mobile')
    if (tokenData) {
      const parsedTokenData = JSON.parse(tokenData)
      
      // 检查令牌是否过期
      const currentTime = Math.floor(Date.now() / 1000)
      if (parsedTokenData.expire && currentTime > parsedTokenData.expire) {
        return null
      }
      
      return parsedTokenData
    }
  } catch (e) {
    try {
      // 尝试Base64解码
      const jsonString = atob(token)
      const parsedTokenData = JSON.parse(jsonString)
      
      // 检查令牌是否过期
      const currentTime = Math.floor(Date.now() / 1000)
      if (parsedTokenData.expire && currentTime > parsedTokenData.expire) {
        return null
      }
      
      return parsedTokenData
    } catch (e) {
      return null
    }
  }
  return null
} 